import moment from "moment";

import { providerRequests } from "@/api/(requests)/provider";
import { scheduleRequests } from "@/api/(requests)/schedule";

import * as actionTypes from "./actionTypes";

export const addNewPatient = (formData) => (_dispatch) =>
  // errorToastHook on httpAuth2 fires a toast for this request.
  providerRequests.create_new_patient({ data: formData }).catch((err) => {
    throw err;
  });

const updateProviderScheduleCallList = (data) => {
  return {
    data,
    type: actionTypes.PROVIDER_UPDATE_SCHEDULE_CALL_LIST,
  };
};

// ----------- Thunks --------------

const fetchProviderScheduleCallList =
  ({ searchParams } = {}) =>
  async (dispatch) => {
    const scheduleSearchParams = {
      local_end_date_time: searchParams.end_date,
      local_start_date_time: searchParams.start_date,
      show_deleted: true,
      show_unjoinable: searchParams.show_deleted,
      timezone: moment.tz.guess(),
    };

    if (searchParams.provider_id) {
      scheduleSearchParams.provider_id = searchParams.provider_id;
    }

    return scheduleRequests
      .get_schedule({ context: { showLoader: false }, searchParams: scheduleSearchParams })
      .then((data) => {
        dispatch(
          updateProviderScheduleCallList({
            providerId: searchParams.provider_id,
            scheduleCallList: {
              awayList: data.away,
              callList: data.schedule,
              endDate: searchParams.end_date,
              showDeleted: searchParams.show_deleted,
              startDate: searchParams.start_date,
            },
          }),
        );
      });
  };
